import {
  useObtenerBalanceComprobacion,
  useObtenerBalanceComprobacionDetalle,
  useObtenerPeriodosContablesV2,
  useObtenerPeriodosFiscalesV2,
  useExpresadoEnV2,
  useObtenerCuentasV2,
  useFuentesDocumentoV2,
  useObtenerDiarioRazonV2,
  useObtenerMayorGeneral,
} from "../../Scripts/Services/contabilidad-service.js";
import {CheckboxField} from "../../../Commons/Scripts/Componentes/CheckboxField";
import {useForm} from "../../../Commons/Scripts/Hooks/useForm";
import {UrlReporte, useImprimir} from "../../../Commons/Scripts/Hooks/useImprimir";
import {formatearNumero, formatearNumeroPorTipoExpresion} from "../../../Commons/Scripts/Utils/formatear";
import {Message, useMessage} from "../../../Commons/Scripts/Componentes/Message";
import React, {useEffect, useState, useRef} from 'react';
import { TreeTable, Column, ColumnGroup, Row, DataTable, Skeleton } from 'primereact';
import {DateField} from "../../../Commons/Scripts/Componentes/DateField";
import {SelectField} from "../../../Commons/Scripts/Componentes/SelectField";
import {RadioButtonField} from "../../../Commons/Scripts/Componentes/RadioButtonField";
import {Button2} from "../../../Commons/Scripts/Componentes/Button";
import {OcultarCelda} from "./Common/OcultarCelda";
import {LinkRD} from "./Common/LinkRD";
import {MayorGeneral} from "./mayor-general";
import {SimpleForm} from "../../../Commons/Scripts/Componentes/Form";

const origin = window.location.origin;

function Formulario({
  onSubmit,
  valorInicial = {},
  periodosContables,
  periodosFiscales,
  expresadosEn,
  onChange,
  loading,
  where,
}) {
  const form = useForm(valorInicial);

  const [desabilitarAuxiliares, setDesabilitarAuxiliares] = useState(false);

  const [loadingPdf, handlePdf] = useImprimir(UrlReporte.BALANCE_COMPROBACION, "PDF");
  const [loadingExcel, handleExcel] = useImprimir(UrlReporte.BALANCE_COMPROBACION, "Excel");
  const [loadingCsv, handleCsv] = useImprimir(UrlReporte.BALANCE_COMPROBACION, "CSV");

  useEffect(() => {
    if (expresadosEn) {
      form.setValue("expresadoEn", expresadosEn[0]);
    }
  }, [expresadosEn]);

  useEffect(() => {
    if (form?.values?.tipo === "detalle") {
      form.setValue("auxiliares", true);
      setDesabilitarAuxiliares(true);
    } else {
      setDesabilitarAuxiliares(false);
    }
  }, [form.values.tipo]);

  const handleSubmit = () => {
    onSubmit(form.values);
  };

  return (
    <SimpleForm formulario={form} onChange={onChange}>
      <div className="contenedorFormulario">
        <div className="superior">
          {form.getValue("tipo") === "comparativo" && (
            <div className="row">
              <DateField name="fechaInicio" label="Fecha Inicio" mostrarIcono={true} />
            </div>
          )}
          <div className="row">
            <DateField name="fechaFin" label="Fecha Fin" mostrarIcono={true} />
          </div>
        </div>
        <div className="medio">
          <div className="row">
            <SelectField
              name="periodoFiscal"
              opciones={periodosFiscales}
              placeholder="Seleccione un período fiscal"
              label="Periodo Fiscal"
              opcionPorDefecto={true}
              width="235px"
            />
            <span style={{ marginRight: "15px" }}>-</span>
            <SelectField
              name="periodoFiscalFin"
              opciones={periodosFiscales}
              placeholder="Seleccione un período fiscal"
              opcionPorDefecto={true}
              width="235px"
            />
          </div>
          <div className="row">
            <SelectField
              name="periodoContable"
              opciones={periodosContables}
              placeholder="Seleccione un período contable"
              label="Periodo Contable"
              opcionPorDefecto={true}
              width="235px"
            />
            <span style={{ marginRight: "15px" }}>-</span>
            <SelectField
              name="periodoContableFin"
              opciones={periodosContables}
              placeholder="Seleccione un período contable"
              opcionPorDefecto={true}
              width="235px"
            />
          </div>
        </div>
        <div className="expresado">
          <div className="row">
            <SelectField name="expresadoEn" opciones={expresadosEn} label="Expresado en" style={{ width: "40%" }} />
          </div>
        </div>
        <div className="inferior">
          <div className="row">
            <label className="label">Incluir</label>
            <div className="control">
              <div style={{ display: "flex", gap: "0 5px" }}>
                <CheckboxField name="detalles" label="Detalles" />
                <CheckboxField name="auxiliares" label="Auxiliares" disabled={desabilitarAuxiliares} />
              </div>
            </div>
          </div>
          <div className="row">
            <label className="label">Tipo</label>
            <div className="control">
              <div style={{ display: "flex", alignItems: "center", gap: "0 5px" }}>
                <RadioButtonField name="tipo" label="Normal" value="normal" />
                <RadioButtonField name="tipo" label="Comparativo" value="comparativo" />
                <RadioButtonField name="tipo" label="Detalle" value="detalle" />
              </div>
            </div>
          </div>

          <div
            style={{
              display: "flex",
              gap: "0 5px",
              margin: "10px 0 10px 150px",
            }}
          >
            <Button2 texto={loading ? "Buscando" : "Buscar"} icono="buscar" onClick={handleSubmit} loading={loading} />
            <Button2 texto="PDF" icono="pdf" loading={loadingPdf} onClick={() => handlePdf({ ...where.where })} />
            <Button2
              texto="Excel"
              icono="excel"
              loading={loadingExcel}
              onClick={() => handleExcel({ ...where.where })}
            />
            <Button2 texto="CSV" icono="archivo" loading={loadingCsv} onClick={() => handleCsv({ ...where.where })} />
          </div>
        </div>
      </div>
    </SimpleForm>
  );
}

function Tabla({ data, loading, expresado, handleFiltros }) {
  const [expandedKeys, setExpandedKeys] = React.useState({});

  const handleExpandir = (e) => {
    const clickedColumnIndex = e.originalEvent.target.cellIndex;

    if (clickedColumnIndex === 0) {
      const newExpandedKeys = { ...expandedKeys };
      if (newExpandedKeys[e.node.key]) {
        delete newExpandedKeys[e.node.key];
      } else {
        newExpandedKeys[e.node.key] = true;
      }
      setExpandedKeys(newExpandedKeys);
    }
  };

  const filtros = (item) => {
    handleFiltros({
      IdentificadorCuenta: item.data.IdentificadorCuenta,
    });
  };

  if (loading) {
    return (
      <DataTable showHeaders={false} value={Array.from({ length: 30 })}>
        <Column body={<Skeleton style={{ height: "40px" }} />} />
      </DataTable>
    );
  }

  return (
    <div>
      <TreeTable
        id="grid"
        value={data}
        tableStyle={{ minWidth: "40rem" }}
        loading={loading}
        expandedKeys={expandedKeys}
        onToggle={(e) => setExpandedKeys(e.value)}
        onRowClick={handleExpandir}
        rowClassName={(item) => ({
          "total-row": item.data.IdentificadorCuenta === "Total",
          "subtotal-row": item.data.IdentificadorCuenta === "Subtotal",
        })}
        emptyMessage="No se han encontrado resultados"
      >
        <Column field="CuentaDesc" style={{ width: "50%", cursor: "pointer" }} expander />
        <Column
          body={(item) => {
            return (
              <OcultarCelda item={item} expandedKeys={expandedKeys}>
                <LinkRD item={item} onClick={() => filtros(item)}>
                  {formatearNumero(formatearNumeroPorTipoExpresion(item.data.DebitoAcumulado, expresado))}
                </LinkRD>
              </OcultarCelda>
            );
          }}
          header="Débito"
          style={{ textAlign: "right", verticalAlign: "middle" }}
        />
        <Column
          body={(item) => {
            return (
              <OcultarCelda item={item} expandedKeys={expandedKeys}>
                    <LinkRD item={item} onClick={() => filtros(item)}>
                  {formatearNumero(formatearNumeroPorTipoExpresion(item.data.CreditoAcumulado, expresado))}
                </LinkRD>
              </OcultarCelda>
            );
          }}
          header="Crédito"
          style={{ textAlign: "right", verticalAlign: "middle" }}
        />
      </TreeTable>
    </div>
  );
}

function TablaComparativo({ data, loading, expresado, handleFiltros }) {
  const [expandedKeys, setExpandedKeys] = React.useState({});

  const handleExpandir = (e) => {
    const clickedColumnIndex = e.originalEvent.target.cellIndex;

    if (clickedColumnIndex === 0) {
      const newExpandedKeys = { ...expandedKeys };
      if (newExpandedKeys[e.node.key]) {
        delete newExpandedKeys[e.node.key];
      } else {
        newExpandedKeys[e.node.key] = true;
      }
      setExpandedKeys(newExpandedKeys);
    }
  };

  const filtros = (item) => {
    handleFiltros({
      IdentificadorCuenta: item.data.IdentificadorCuenta,
    });
  };

  const headerGroup = (
    <ColumnGroup>
      <Row>
        <Column style={{ width: "25%" }} />
        <Column header="Saldo Inicial" colSpan={2} style={{ textAlign: "center" }} />

        <Column header="Saldo Período Actual" colSpan={2} style={{ textAlign: "center" }} />
        <Column header="Saldo Final" colSpan={2} style={{ textAlign: "center" }} />
      </Row>
      <Row>
        <Column />
        <Column header="Débito" style={{ textAlign: "right" }} />
        <Column header="Crédito" style={{ textAlign: "right" }} />
        <Column header="Débito" style={{ textAlign: "right" }} />
        <Column header="Crédito" style={{ textAlign: "right" }} />
        <Column header="Débito" style={{ textAlign: "right" }} />
        <Column header="Crédito" style={{ textAlign: "right" }} />
      </Row>
    </ColumnGroup>
  );

  return (
    <div>
      <TreeTable
        id="grid"
        value={data}
        tableStyle={{ minWidth: "40rem" }}
        loading={loading}
        expandedKeys={expandedKeys}
        onToggle={(e) => setExpandedKeys(e.value)}
        onRowClick={handleExpandir}
        rowClassName={(item) => {
          return {
            "total-row": item.data.IdentificadorCuenta === "Total",
            "subtotal-row": item.data.IdentificadorCuenta === "Subtotal",
          };
        }}
        headerColumnGroup={headerGroup}
        emptyMessage="No se han encontrado resultados"
      >
        <Column
          body={(item) => {
            return (
              <span
                onClick={(e) => {
                  const thElement = e.target.closest("td");
                  if (thElement) {
                    thElement.click();
                  }
                }}
              >
                {item.data.CuentaDesc}
              </span>
            );
          }}
          style={{ cursor: "pointer", display: "flex", alignItems: "center" }}
          expander
        />
        <Column
          body={(item) => {
            return (
              <OcultarCelda item={item} expandedKeys={expandedKeys}>
                    <LinkRD item={item} onClick={() => filtros(item)}>
                  {formatearNumero(formatearNumeroPorTipoExpresion(item.data.DebitoPeriodoAnterior, expresado))}
                    </LinkRD>
              </OcultarCelda>
            );
          }}
          style={{ textAlign: "right", verticalAlign: "middle" }}
        />
        <Column
          body={(item) => {
            return (
              <OcultarCelda item={item} expandedKeys={expandedKeys}>
                    <LinkRD item={item} onClick={() => filtros(item)}>
                  {formatearNumero(formatearNumeroPorTipoExpresion(item.data.CreditoPeriodoAnterior, expresado))}
                    </LinkRD>
              </OcultarCelda>
            );
          }}
          style={{ textAlign: "right", verticalAlign: "middle" }}
        />
        <Column
          body={(item) => {
            return (
              <OcultarCelda item={item} expandedKeys={expandedKeys}>
                    <LinkRD item={item} onClick={() => filtros(item)}>
                  {formatearNumero(formatearNumeroPorTipoExpresion(item.data.DebitoPeriodoActual, expresado))}
                    </LinkRD>
              </OcultarCelda>
            );
          }}
          style={{ textAlign: "right", verticalAlign: "middle" }}
        />
        <Column
          body={(item) => {
            return (
              <OcultarCelda item={item} expandedKeys={expandedKeys}>
                    <LinkRD item={item} onClick={() => filtros(item)}>
                  {formatearNumero(formatearNumeroPorTipoExpresion(item.data.CreditoPeriodoActual, expresado))}
                    </LinkRD>
              </OcultarCelda>
            );
          }}
          style={{ textAlign: "right", verticalAlign: "middle" }}
        />
        <Column
          body={(item) => {
            return (
              <OcultarCelda item={item} expandedKeys={expandedKeys}>
                    <LinkRD item={item} onClick={() => filtros(item)}>
                  {formatearNumero(formatearNumeroPorTipoExpresion(item.data.DebitoAcumulado, expresado))}
                    </LinkRD>
              </OcultarCelda>
            );
          }}
          style={{ textAlign: "right", verticalAlign: "middle" }}
        />
        <Column
          body={(item) => {
            return (
              <OcultarCelda item={item} expandedKeys={expandedKeys}>
                    <LinkRD item={item} onClick={() => filtros(item)}>
                  {formatearNumero(formatearNumeroPorTipoExpresion(item.data.CreditoAcumulado, expresado))}
                    </LinkRD>
              </OcultarCelda>
            );
          }}
          style={{ textAlign: "right", verticalAlign: "middle" }}
        />
      </TreeTable>
    </div>
  );
}

function TablaDetalle({ data, loading, expresado }) {
  const filtros = (item) => {
    handleFiltros({
      IdentificadorCuenta: item.data.IdentificadorCuenta,
    });
  };

  if (loading) {
    return (
      <DataTable showHeaders={false} value={Array.from({ length: 30 })}>
        <Column body={<Skeleton style={{ height: "40px" }} />} />
      </DataTable>
    );
  }

  return (
    <DataTable id="grid" value={data} emptyMessage="No hay resultados">
      <Column header="Cuenta" field="IdentificadorCuenta" />
      <Column header="Nombre" field="Descripcion" />
      <Column
        headerClassName="align-right"
        style={{ textAlign: "right" }}
        header="Débito "
        field="DebitoAcumulado"
        body={(item) => {
          const formateado = formatearNumero(formatearNumeroPorTipoExpresion(item.DebitoAcumulado, expresado));
          return <span>{formateado}</span>;
        }}
      />
      <Column
        headerClassName="align-right"
        style={{ textAlign: "right" }}
        header="Crédito"
        field="CreditoAcumulado"
        body={(item) => {
          const formateado = formatearNumero(formatearNumeroPorTipoExpresion(item.CreditoAcumulado, expresado));
          return <span>{formateado}</span>;
        }}
      />
    </DataTable>
  );
}

export function BalanceComprabacion() {
  const { messages, typeMessages, handleException, clearMessages } = useMessage();

  const [tab, setTab] = React.useState("BALANCE_COMPROBACION");

  const isBalanceComprobacion = tab === "BALANCE_COMPROBACION";
  const isMayorGeneral = tab === "MAYOR_GENERAL";

  const [where, setWhere] = useState({
    where: {
      FechaInicio: new Date(new Date().setMonth(new Date().getMonth() - 1)),
      FechaFin: new Date(),
      ReporteTipo: "normal",
      IncluirDetalles: true,
    },
  });
  const [whereMayorGeneral, setWhereMayorGeneral] = useState({
    where: {
      FechaInicio: new Date(new Date().setMonth(new Date().getMonth() - 1)),
      FechaFin: new Date(),
    },
  });
  const [wherePeriodoContable, setWherePeriodoContable] = useState();

  const { data, loading, error } = useObtenerBalanceComprobacion(where);
  const { data: dataDetalle, loading: loadingDetalle } = useObtenerBalanceComprobacionDetalle(where);

  const { data: periodosFiscales } = useObtenerPeriodosFiscalesV2();
  const { data: periodosContables } = useObtenerPeriodosContablesV2(wherePeriodoContable);
  const { data: expresadosEn } = useExpresadoEnV2();

  const [tipo, setTipo] = useState("normal");
  const [expresado, setExpresado] = useState(null);

  /* mayor general */
  const [wherePeriodoContableMG, setWherePeriodoContableMG] = useState();

  const { data: periodosContablesMG } = useObtenerPeriodosContablesV2(wherePeriodoContableMG);
  const { data: cuentas } = useObtenerCuentasV2();
  const { data: fuentesDocumento } = useFuentesDocumentoV2();
  const { data: razones } = useObtenerDiarioRazonV2();
  const {
    data: dataMayorGeneral,
    loading: loadingMayorGeneral,
    error: errorMayorGeneral,
  } = useObtenerMayorGeneral(whereMayorGeneral);

  const [filtros, setFiltros] = useState({});
  const [filtro, setFiltro] = useState(false);

  const handleOnChangeFormulario = (formulario) => {
    if (formulario.tipo) {
      setTipo(formulario.tipo);
    }
    if (formulario.expresadoEn) {
      setExpresado(formulario.expresadoEn?.value);
    }
    if (formulario.periodoFiscal) {
      setWherePeriodoContable({
        PeriodoFiscalIdSec: formulario.periodoFiscal?.value,
      });
    }
    if (formulario.tipo !== where?.where?.ReporteTipo) {
      setWhere({ where: { ...where.where, ReporteTipo: formulario.tipo } });
    }
  };

  /* mayor general */
  const handleOnChangeFormularioMG = (formulario) => {
    if (formulario.cuenta && filtros?.IdentificadorCuenta && !filtro) {
      setWhereMayorGeneral({
        where: {
          FechaInicio: formulario.fechaInicio,
          FechaFin: formulario.fechaFin,
          PeriodoFiscalIdSec: formulario.periodoFiscal?.value,
          PeriodoContableIdSec: formulario.periodoContable?.value,
          TipoDocumentoIdSec: formulario.tipoDocumento?.value,
          CuentasIdentificadorLista: formulario.cuenta?.map((item) => item.value),
          SinMovimiento: formulario.sinMovimiento,
        },
      });
      setFiltro(true);
    }
  };

  const handleSubmitMG = (formulario) => {
    setWhereMayorGeneral({
      where: {
        FechaInicio: formulario.fechaInicio,
        FechaFin: formulario.fechaFin,
        PeriodoFiscalIdSec: formulario.periodoFiscal?.value,
        PeriodoContableIdSec: formulario.periodoContable?.value,
        TipoDocumentoIdSec: formulario.tipoDocumento?.value,
        CuentasIdentificadorLista: formulario.cuenta?.map((item) => item.value),
        SinMovimiento: formulario.sinMovimiento,
      },
    });
    setFiltro(false);
  };

  /* mayor general */
  const handleFiltros = (filtro) => {
    setTab("MAYOR_GENERAL");
    setFiltros(filtro);
    setFiltro(false);
  };

  useEffect(() => {
    clearMessages();
    handleException(error);
    handleException(errorMayorGeneral);
  }, [error, errorMayorGeneral]);

  return (
    <div className="contenedor">
      <div className={isBalanceComprobacion ? "" : "hidden"}>
        <div>
          <Message messages={messages} type={typeMessages} />
          <Formulario
            onSublario
            onSubmit={(formulario) => {
              setWhere({
                where: {
                  FechaInicio: formulario?.fechaInicio,
                  FechaFin: formulario.fechaFin,
                  PeriodoFiscalInicioIdSec: formulario.periodoFiscal?.value,
                  PeriodoContableInicioIdSec: formulario.periodoContable?.value,
                  PeriodoFiscalFinIdSec: formulario.periodoFiscalFin?.value,
                  PeriodoContableFinIdSec: formulario.periodoContableFin?.value,
                  IncluirDetalles: formulario?.detalles,
                  IncluirAuxiliares: formulario?.auxiliares,
                  ReporteTipo: formulario.tipo,
                },
              });
            }}
            valorInicial={{
              fechaInicio: new Date(new Date().setMonth(new Date().getMonth() - 1)),
              fechaFin: new Date(),
              tipo: "normal",
              detalles: true,
            }}
            periodosContables={periodosContables}
            periodosFiscales={periodosFiscales}
            expresadosEn={expresadosEn}
            onChange={handleOnChangeFormulario}
            loading={loading}
            where={where}
          />
        </div>

        <br />
        <br />
        <div className="inMenu">
          <div className="inMenuItem">
            <span
              className={isBalanceComprobacion ? "subTitle" : "linkSubtitulo"}
              onClick={() => setTab("BALANCE_COMPROBACION")}
            >
              Balanza Comprobación
            </span>
          </div>
          <div className="inMenuItem">|</div>
          <div className="inMenuItem">
            <span className={isMayorGeneral ? "subTitle" : "linkSubtitulo"} onClick={() => setTab("MAYOR_GENERAL")}>
              Mayor General
            </span>
          </div>
          <div className="fix"></div>
        </div>
        <br />

        {tipo === "normal" && (
          <Tabla data={data} loading={loading} expresado={expresado} handleFiltros={handleFiltros} />
        )}
        {tipo === "comparativo" && (
          <TablaComparativo data={data} loading={loading} expresado={expresado} handleFiltros={handleFiltros} />
        )}
        {tipo === "detalle" && <TablaDetalle data={dataDetalle} loading={loadingDetalle} expresado={expresado} />}
      </div>
      <div className={isMayorGeneral ? "" : "hidden"}>
        <div>
          <Message messages={messages} type={typeMessages} />
          <MayorGeneral
            handleSubmitMG={handleSubmitMG}
            valorInicial={{
              fechaInicio: new Date(new Date().setMonth(new Date().getMonth() - 1)),
              fechaFin: new Date(),
            }}
            periodosContablesMG={periodosContablesMG}
            periodosFiscales={periodosFiscales}
            expresadosEn={expresadosEn}
            cuentas={cuentas}
            fuentesDocumento={fuentesDocumento}
            handleOnChangeFormularioMG={handleOnChangeFormularioMG}
            filtros={filtros}
            filtro={filtro}
            data={dataMayorGeneral}
            loading={loadingMayorGeneral}
            where={whereMayorGeneral}
            isBalanceComprobacion={isBalanceComprobacion}
            isMayorGeneral={isMayorGeneral}
            setTab={setTab}
            razones={razones}
          />
        </div>
      </div>
    </div>
  );
}
